import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass, NgIf } from '@angular/common';
import { ReactiveFormsModule, FormGroup } from '@angular/forms';
import { MiddlearticlesInterface } from 'src/_lib/interfaces/performance-section.interface';
import { environment } from 'src/environments/environment.prod';
import { DynamicThemeClassService } from 'src/_lib/service/dynamic-theme-class.service';

@Component({
  selector: 'app-subscribe-ch1',
  templateUrl: './subscribe-ch1.component.html',
  styleUrls: [
    './subscribe-ch1.component.scss',
  ],
  standalone: true,
  imports: [ReactiveFormsModule, NgIf, NgClass],
})
export class SubscribeCh1Component {
  cdnImagePath = environment.cdnImagePath;
  commonImagePath: string = environment.commonImagePath;
  subscribeButtonArrow: string = environment.subscribeButtonArrow;
  chTheme4 = environment.chTheme4;
  chTheme6 = environment.chTheme6;
  chTheme7 = environment.chTheme7;
  chTheme9 = environment.chTheme9;
  chTheme10 = environment.chTheme10;
  chTheme12 = environment.chTheme12;
  @Input() index9: any;
  // subArrow=environment.subArrow;
  imageBasePath: string = environment.imageBasePath;
  @Input() emaildata: MiddlearticlesInterface[] = [];
  @Output() onSubmit = new EventEmitter<any>();
  @Input() emailForm: FormGroup;
  @Input() errorMessage: string = '';

  constructor(private dynamicThemeClassService: DynamicThemeClassService) {}

  themeClass(divName: string): string {
    return this.dynamicThemeClassService.generateClassName(divName);
  }
}